import type { AssetSheetColumnMapUpdateInput } from '@atlas/models'
import type { AssetSheetColumnMapEntryDTO, AssetSheetColumnMapTabDTO } from '@atlas/types'
import { apiClient } from './api.client'

export interface AssetSheetColumnMapUpdateResult {
	entries: AssetSheetColumnMapEntryDTO[]
	auditRecorded: boolean
}

/** ADMIN-only: where each column of each tab of the asset sheet goes. */
export const assetSheetColumnMapApi = {
	list: (): Promise<AssetSheetColumnMapTabDTO[]> =>
		apiClient.get<{ data: AssetSheetColumnMapTabDTO[] }>('/admin/asset-sheet/column-map').then((r) => r.data.data),

	/**
	 * Change one column, on its tab or on every tab; resolves to every entry changed, and whether
	 * the change was recorded in the activity log. It is saved either way.
	 */
	update: (id: string, input: AssetSheetColumnMapUpdateInput): Promise<AssetSheetColumnMapUpdateResult> =>
		apiClient
			.patch<{ data: AssetSheetColumnMapEntryDTO[]; auditRecorded: boolean }>(
				`/admin/asset-sheet/column-map/${encodeURIComponent(id)}`,
				input,
			)
			.then((r) => ({ entries: r.data.data, auditRecorded: r.data.auditRecorded })),
}
